export default __webpack_public_path__ + "static/media/team101.b625a773.JPG";